var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-select',{attrs:{"clearable":"","placeholder":"请选择类型"},on:{"input":_vm.sendType},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }